import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import '../styles/floatingForm.css';
import '../styles/dataTable.css';

const UpdatePlanInPage = () => {

  const navigate = useNavigate();
  const { id } = useParams();

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  const [planName, setPlanName] = useState('');
  const [price, setPrice] = useState('');
  const [noofpackge, setNoofpackge] = useState('');
  const [rank, setRank] = useState('');
  const [planetype, setPlanetype] = useState('Monthly');
  const [isActive, setIsActive] = useState('1');
  const [durationDays, setDurationDays] = useState('');
  const [planDescription, setPlanDescription] = useState('');
  const [features, setFeatures] = useState([]);


  // --------------------------------------------------
  // FETCH PLAN
  // --------------------------------------------------

  useEffect(() => {

    const fetchPlan = async () => {

      try {

        const res =
          await api.get(
            `/service-plan/get-all`
          );

        const plan =
          res.data.data?.find(
            p => String(p.id) === String(id)
          );

        console.log(
          "Fetched plan for editing:",
          plan
        );


        if (!plan) {

          toast.error(
            "Plan not found"
          );

          navigate('/plan-types');

          return;

        }


        setPlanName(
          plan.plan_name || ''
        );

        setPrice(
          plan.price || ''
        );

        setNoofpackge(
          plan.noofpackge || ''
        );

        setRank(
          plan.rank || ''
        );

        setIsActive(
          plan.is_active !== undefined
            ? String(plan.is_active)
            : '1'
        );

        setDurationDays(
          plan.duration_days || ''
        );

        setPlanDescription(
          plan.plan_discription || ''
        );

        setPlanetype(
          plan.plan_type || 'Monthly'
        );


        setFeatures(

          plan.features?.map(
            f => ({
              serviceplantitle:
                f.serviceplantitle || '',

              serviceplandiscription:
                f.serviceplandiscription || ''
            })
          ) || []

        );

      } catch (err) {

        console.error(err);

        toast.error(
          'Error loading plan'
        );

      } finally {

        setFetching(false);

      }

    };


    if (id) {
      fetchPlan();
    } else {
      setFetching(false);
      navigate('/plan-types');
    }

  }, [id, navigate]);


  // --------------------------------------------------
  // CANCEL / BACK
  // --------------------------------------------------

  const handleCancel = () => {

    navigate('/plan-types');

  };


  // --------------------------------------------------
  // VALIDATION
  // --------------------------------------------------

  const validateForm = () => {

    const newErrors = {};


    if (!planName.trim()) {

      newErrors.planName =
        "Plan Name cannot be empty";

    }


    if (!price.trim()) {

      newErrors.price =
        "Price cannot be empty";

    } else if (isNaN(price)) {

      newErrors.price =
        "Invalid price";

    }


    if (!noofpackge.trim()) {

      newErrors.noofpackge =
        "Required";

    } else if (isNaN(noofpackge)) {

      newErrors.noofpackge =
        "Invalid";

    }


    if (!rank.trim()) {

      newErrors.rank =
        "Required";

    } else if (isNaN(rank)) {

      newErrors.rank =
        "Invalid";

    }


    if (!durationDays.trim()) {

      newErrors.durationDays =
        "Required";

    } else if (isNaN(durationDays)) {

      newErrors.durationDays =
        "Invalid";

    }


    return newErrors;

  };


  // --------------------------------------------------
  // FEATURE HANDLERS
  // --------------------------------------------------

  const addFeature = () => {

    setFeatures([
      ...features,
      {
        serviceplantitle: '',
        serviceplandiscription: ''
      }
    ]);

  };


  const handleFeatureChange = (
    index,
    field,
    value
  ) => {

    const updated =
      [...features];

    updated[index][field] =
      value;

    setFeatures(updated);

  };


  const removeFeature = (index) => {

    setFeatures(
      features.filter(
        (_, i) => i !== index
      )
    );

  };


  // --------------------------------------------------
  // SUBMIT
  // --------------------------------------------------

  const handleSubmit = async (e) => {

    e.preventDefault();


    const newErrors =
      validateForm();


    if (
      Object.keys(newErrors).length > 0
    ) {

      setErrors(newErrors);

      toast.error(
        "Please fill all required fields correctly"
      );

      return;

    }


    setErrors({});
    setLoading(true);


    try {

      const formData =
        new FormData();


      // BASIC FIELDS

      formData.append(
        "plan_name",
        planName
      );

      formData.append(
        "price",
        price
      );

      formData.append(
        "noofpackge",
        noofpackge
      );

      formData.append(
        "rank",
        rank
      );

      formData.append(
        "is_active",
        isActive
      );

      formData.append(
        "duration_days",
        durationDays
      );

      formData.append(
        "plan_discription",
        planDescription
      );

      formData.append(
        "plan_type",
        planetype
      );


      // FEATURES

      features.forEach((f) => {

        formData.append(
          "serviceplantitle[]",
          f.serviceplantitle || ""
        );

        formData.append(
          "serviceplandiscription[]",
          f.serviceplandiscription || ""
        );

      });


      // DEBUG

      for (
        let pair of formData.entries()
      ) {

        console.log(
          pair[0],
          pair[1]
        );

      }


      const response =
        await api.post(
          `/service-plan/update/${id}`,
          formData
        );


      if (
        response.data.status === "success"
      ) {

        toast.success(
          "Plan updated successfully!"
        );

        navigate('/plan-types');

      } else {

        toast.error(
          "Failed to update plan"
        );

      }

    } catch (error) {

      console.error(error);

      toast.error(
        "Error updating plan"
      );

    } finally {

      setLoading(false);

    }

  };

  if (fetching) {
    return (
      <div className='floating-form-container' >
        <div className="heading">
          <h2>Loading...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className='floating-form-container' >
      <div className="heading">
        <h2>Update Service Plan</h2>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-container">
          <div className="section-1">

            {/* SAME UI — ONLY BINDING */}

            <div className="input-container-floating-form wid-50">
              <label>Plan Name *</label>
              <input value={planName} onChange={(e)=>setPlanName(e.target.value)} />
              {errors.planName && <span className='text-danger small'>{errors.planName}</span>}
            </div>

            <div className="input-container-floating-form wid-50">
              <label>Price *</label>
              <input type="number" value={price} onChange={(e)=>setPrice(e.target.value)} />
              {errors.price && <span className='text-danger small'>{errors.price}</span>}
            </div>

            <div className="input-container-floating-form wid-50">
              <label>Number of Packages *</label>
              <input type="number" value={noofpackge} onChange={(e)=>setNoofpackge(e.target.value)} />
            </div>

            <div className="input-container-floating-form wid-50">
              <label>Rank *</label>
              <input type="number" value={rank} onChange={(e)=>setRank(e.target.value)} />
            </div>

            <div className="input-container-floating-form wid-50">
              <label>Duration (Days) *</label>
              <input type="number" value={durationDays} onChange={(e)=>setDurationDays(e.target.value)} />
            </div>

            <div className="input-container-floating-form wid-50">
              <label>Plan Type *</label>
              <select value={planetype} onChange={(e)=>setPlanetype(e.target.value)}>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>

            <div className="input-container-floating-form wid-50">
              <label>Status *</label>
              <select value={isActive} onChange={(e)=>setIsActive(e.target.value)}>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>

  

            {/* FEATURES (same UI style) */}
            <div className="input-container-floating-form wid-100 mt-3 display-flex flex-direction-column">
              <label>Features *</label>

              <div className='action-btn button d-flex' style={{ marginBottom: "10px" }}>
                <button type="button" onClick={addFeature}>
                  + Add Feature
                </button>
              </div>

              {features.map((feature, index) => (
                <div key={index} className="feature-box" style={{ marginBottom: "15px" }}>

                  <input
                    type="text"
                    placeholder="Feature Title"
                    value={feature.serviceplantitle}
                    onChange={(e)=>handleFeatureChange(index,'serviceplantitle',e.target.value)}
                    className={`input-container-floating-form wid-50 mb-2 ${errors[`feature_title_${index}`] ? 'is-invalid' : ''}`}
                  />

                  {errors[`feature_title_${index}`] && (
                    <span className="text-danger small">{errors[`feature_title_${index}`]}</span>
                  )}

                  <input
                    type="text"
                    placeholder="Feature Description"
                    value={feature.serviceplandiscription}
                    onChange={(e)=>handleFeatureChange(index,'serviceplandiscription',e.target.value)}
                    className={`input-container-floating-form mb-2 wid-50 ${errors[`feature_desc_${index}`] ? 'is-invalid' : ''}`}
                  />
                <hr />

                  {errors[`feature_desc_${index}`] && (
                    <span className="text-danger small">{errors[`feature_desc_${index}`]}</span>
                  )}

                </div>
              ))}

              {errors.features && <span className="text-danger small">{errors.features}</span>}
            </div>


          </div>

          <div className="form-btn-container">
            <button type='submit' disabled={loading}>
              {loading ? 'Updating...' : 'Update Plan'}
            </button>
            <button type='button' onClick={handleCancel}>Cancel</button>
          </div>

        </div>
      </form>
    </div>
  );
};

export default UpdatePlanInPage;